import { render, staticRenderFns } from "./DeleteMenuDialog.vue?vue&type=template&id=e97d6a1a&scoped=true&"
import script from "./DeleteMenuDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteMenuDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97d6a1a",
  null
  
)

export default component.exports